<template>
    <div class="daily-deals-inner p-2">
        <div class="daily-deals-top">
            <a :href="productUrl" class="product-image">
                <img :src="baseImage" :class="{ 'image-placeholder': ! hasBaseImage }" alt="product-image">
            </a>
        </div>
          <ul class="list-inline product-badge">
            <li v-if="product.is_out_of_stock" class="mb-2">
                {{ $trans('ecommerce::product_card.out_of_stock') }}
            </li>

            <li v-if="product.has_percentage_special_price" class="special-price-percent mb-2">
                -{{ product.special_price_percent }}%
            </li>

            <li class="product-new" v-else-if="product.is_new">
                {{ $trans('ecommerce::product_card.new') }}
            </li>

        </ul>
        <div class="product-card-info">
            <div class="product-price" v-if="mask == 0" v-html="product.formatted_price"></div>
            <div class="product-price" v-if="mask == 1" v-html="maskPriceHtml"></div>

            <a :href="productUrl" class="product-name"><h6><span v-if="product.brand.name" class="item-brand mr-1">{{ product.brand.name }}</span>{{ product.name }}</h6></a>

            <div class="product-info py-1">
                <ProductRating :ratingPercent="product.rating_percent" :reviewCount="product.reviews.length"/>
                <div class="product-cart">
                    <i class="las la-cart-arrow-down" aria-hidden="true"></i>
                    <span v-html="product.pivot.sold"></span>
                </div>
            </div>
        </div>

        <ProductProgress  :sold="product.sold" :qty="product.qty"/>
    </div>
</template>

<script>
import ProductCardMixin from '../../mixins/ProductCardMixin';
import ProductRating from "../ProductRating.vue";
import ProductProgress from '../ProductProgress.vue';
import ProductSold from '../ProductSold.vue';

export default {
    components: { ProductRating, ProductProgress, ProductSold },
    mixins: [
        ProductCardMixin,
    ],

    props: ['product', 'mask'],

    computed: {
        progress() {
            return (this.product.pivot.sold / this.product.pivot.qty * 100);
        },

        maskPriceHtml() {
            return '??? <span class="previous-price">' + this.product.price.formatted + '</span>';
        },
    },
};
</script>
